import { FC, useMemo } from 'react';
import { CssBaseline, ThemeProvider, useMediaQuery } from '@mui/material';
import { darkTheme, lightTheme } from './themes';
import { newBrandLightTheme, newBrandDarkTheme } from './themeNew';
import { useBrandVersion } from '../../hooks/useBrandVersion';

interface ITransceptaThemeProviderProps {
    enableDarkMode?: boolean;
}

export const TransceptaThemeProvider: FC<ITransceptaThemeProviderProps> = ({ enableDarkMode, children }) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const brandVersion = useBrandVersion();

    const theme = useMemo(() => {
        const isNewBrand = brandVersion === 'newBrand';
        const isDark = enableDarkMode && prefersDarkMode;

        if (isNewBrand) {
            return isDark ? newBrandDarkTheme : newBrandLightTheme;
        }
        return isDark ? darkTheme : lightTheme;
    }, [enableDarkMode, prefersDarkMode, brandVersion]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};
